const Blockly = require('blockly');
const dataAccessMethods = require('../../../../dataAccessMethods');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const convertToBoolean = require('../../../../helpers/convertToBoolean');

const TOOLTIP =
    'Generates a LIST in the MENU, and defines a page that is rendered within the context of the selected menu entry';

/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock reference to the block as a whole
 * @param {Object} mdcBlock Meta Data Configuration block. the group definition from blockGroupConfiguration.js
 * @param {import('blockly').Input} line1OfInputs First line of inputs, already including the Block name and the title field
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    let workspace = blocklyBlock.workspace;
    let blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged horizontally (this is the default)
    //Meaning each (dummy)input continues on the top line
    //We don't have many input fields, and that allows the access modifiers to line up nicer
    blocklyBlock.setInputsInline(true);
    line1OfInputs
        .appendField('  Breadcrumb Trail:')
        .appendField(new Blockly.FieldCheckbox('false'), 'includeBreadcrumb')
        .appendField('  List Namespace:')
        .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
        .appendField('  List Relation:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)), 'relation');

    // line2OfInputs
    blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('  Icon Name:')
        .appendField(new Blockly.FieldTextInput(''), 'iconName')
        .appendField('  Icon Color:')
        .appendField(new Blockly.FieldTextInput(''), 'iconColor');

    blocklyBlock.appendStatementInput('Filters').setCheck(['filter']).appendField('List Filters:', 'filters');

    blocklyBlock
        .appendStatementInput('children')
        .setCheck(mdcBlock.allowedChildrenTypes)
        .appendField('Page Content:', 'childrenField');
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties([
        'namespace',
        'relation',
        'iconName',
        'iconColor',
        { key: 'includeBreadcrumb', handler: convertToBoolean }
    ]);
    return JSON.stringify(code);
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
